<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="众筹投资包"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="courseForm">
        <el-form-item label="投资包名称" prop="package_name">
          <el-input
            v-model="form.package_name"
            placeholder="投资包名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="众筹金额" prop="total_value">
          <el-input
            v-model="form.total_value"
            placeholder="众筹金额/元"
          ></el-input>
        </el-form-item>
         <el-form-item label="众筹成本">
          <el-input
            v-model="form.cost_amount"
            placeholder="众筹成本/元"
          ></el-input>
        </el-form-item>

        <el-form-item label="总份额数" prop="total_shares">
          <el-input
            v-model="form.total_shares"
            placeholder="总份额数"
          ></el-input>
        </el-form-item>
        <el-form-item label="最低认领" prop="min_investment_shares">
          <el-input
            v-model="form.min_investment_shares"
            placeholder="最低认领"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店数量" prop="venue_count">
          <el-input
            v-model="form.venue_count"
            placeholder="门店数量"
          ></el-input>
        </el-form-item>
        <div>
          每份金额 = (众筹金额 + 众筹成本) / 总份数
        </div>
        <el-form-item label="收益时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-DD"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分成比例" prop="divi_rate">
          <el-input
            v-model="form.divi_rate"
            placeholder="利润的分成比例，如0.2"
          ></el-input>
        </el-form-item>
        <el-form-item label="加速比例">
          <el-input
            v-model="form.speed_rate"
            placeholder="加速比例"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目介绍">
            <images-uploader
              @getImgUrl="v => form.imgs = v"
              :urls="temp.imgs"
            >
            </images-uploader>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      dateRange: [],
    };
  },

  mounted() {},

  methods: {
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
        this.dateRange = [info.start_time.split(' ')[0], info.end_time.split(' ')[0]];
      } else {
        this.form = this.temp = Object.assign({}, info);
        this.temp = {};
        this.dateRange = []
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          if(this.dateRange.length == 0){
            this.$message({ type: "error", message: "请选择收益时间!" });
            return
          }
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/investPackageUnion/insert";
      this.form.status = 0;
      this.form.start_time = this.dateRange[0] + ' 00:00:00';
      this.form.end_time = this.dateRange[1] + ' 23:59:59';

      this.$axios.post(url, this.form).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: "warning", message: "添加成功!" });
          this.addServiceDialog = false;
          this.if_clear = true;
          this.form = {};
          this.$emit("success");
        } else {
          this.$message({ type: "error", message: res.data.message });
        }
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
       data.start_time = this.dateRange[0] + ' 00:00:00';
      data.end_time = this.dateRange[1] + ' 23:59:59';
      let url = "/user/investPackageUnion/update";
      this.$axios.post(url, data).then((res) => {
         this.$message({ type: "success", message: "修改成功!" });
          this.addServiceDialog = false;
          this.if_clear = true;
          this.form = {};
          this.temp = {};
          this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>